import { render } from "./createlist.vue?vue&type=template&id=41346196"
import script from "./createlist.vue?vue&type=script&lang=js"
export * from "./createlist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__